export default __webpack_public_path__ + "static/media/SS8-min.d9ff2841.png";